import { FilterableEntry } from '@app/shared/models/filterable-entry';

export interface MetaListOptions<T> {
  calculateMetaData: (item: T) => FilterableEntry;
  countMode: MetaListCountMode;
}

export enum MetaListCountMode {
  /**
   * Counters will be updated, so that they represent the number of elements that match the current
   * property selection.
   */
  Dynamic = 'dynamic',

  /**
   * Counters will stay the same, no matter which properties are selected.
   */
  Static = 'static',
}
